import { DialogDesignTokens } from '@primeuix/themes/types/dialog';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tDeep, tNum } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/dialog/index.ts
const dl = tDeep(componentCommon.dialog);

export const DialogTelekomDT: DialogDesignTokens = {
  root: {
    background: dl.background,
    color: dl.color,
    borderColor: dl.border.color,
    borderRadius: dl.border.radius,
  },
  header: {
    padding: dl.header.padding,
    gap: dl.header.gap,
  },
  title: {
    fontSize: dl.title.font.size,
    fontWeight: tNum(componentCommon.dialog.title.font.weight),
  },
  content: {
    padding: `${dl.content.padding.top} ${dl.content.padding.right} ${dl.content.padding.bottom} ${dl.content.padding.left}`,
  },
  footer: {
    gap: dl.footer.gap,
    padding: `${dl.footer.padding.top} ${dl.footer.padding.right} ${dl.footer.padding.bottom} ${dl.footer.padding.left}`,
  },
};
